import MainPage from './MainPage'
import AboutUsPage from './AboutUsPage'
import ProjectPage from './ProjectPage'
import PortfolioPage from './PortfolioPage'
import JoinUsPage from './JoinUsPage'
import GetInTouchPage from './GetInTouchPage'

export { MainPage, AboutUsPage, ProjectPage, PortfolioPage, JoinUsPage, GetInTouchPage }
